module.exports = __webpack_public_path__ + "assets/img/6.0be86a6e.png";